import { Stack, TextField, Typography } from "@mui/material";
import type { Dispatch, SetStateAction } from "react";
import type { Fund } from "../../../../../api/types/commonApiTypes";
import useSettingsContext from "../../../useSettingsContext";
import ChangesWarningAlert from "../../common/ChangesWarningAlert";
import MemberChangesTable from "../memberChanges/MemberChangesTable";
import type { MemberChange } from "../membersChangeRequestHelper";
import type { NewContactState } from "./newContactState";
import { updateCommentAction } from "./newContactState";

interface Props {
  state: NewContactState;
  setState: Dispatch<SetStateAction<NewContactState>>;
  funds: Fund[];
  comment: string;
}

const NewContactReview = ({ state, setState, funds, comment }: Props) => {
  const { accessCategories } = useSettingsContext();

  const selectedFundNames = funds.filter((fund) => state.selectedFundIds.includes(fund.id)).map((fund) => fund.name);

  const selectedCategoryNames = accessCategories
    .filter((category) => state.selectedCategoryExternalIds.includes(category.externalId))
    .map((category) => category.name);

  const changes: MemberChange[] = state.contacts.map((contact) => ({
    key: String(contact.key),
    name: contact.values.fullName,
    email: contact.values.email,
    action: "CreateNew",
    fundChanges: [
      {
        fundNames: selectedFundNames,
        role: state.role,
        roleChanged: true,
        categoryChanges: selectedCategoryNames.map((name) => ({ name, changeType: "Added" })),
      },
    ],
  }));

  return (
    <Stack spacing={2.5}>
      <ChangesWarningAlert />
      <Stack spacing={1}>
        <Typography variant="subtitle2">Adding contacts ({state.contacts.length})</Typography>
        <MemberChangesTable changes={changes} />
      </Stack>
      <Stack spacing={1} sx={{ width: "100%" }}>
        <Typography variant="subtitle2">Comment</Typography>
        <TextField
          fullWidth
          multiline
          rows={3}
          spellCheck
          placeholder="Add an optional comment for the reviewer..."
          variant="outlined"
          value={comment}
          onChange={(e) => setState(updateCommentAction(e.target.value))}
        />
      </Stack>
    </Stack>
  );
};

export default NewContactReview;
